import * as CONFIG from 'config';
import classnames from 'classnames/bind';
import { useContext, useEffect, useState } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';
import CatalogLink from 'Catalog/CatalogLink';
import { PrevButton, NextButton } from 'Catalog/PagingButtons';
import AutoplayButton from 'Catalog/AutoplayButton';

export default function Navigations() {
  const { activePageInfo, lang, pageNum } = useContext(CatalogContext);
  const [totalMenuOpen, setTotalMenuOpen] = useState(false);

  useEffect(() => {
    setTotalMenuOpen(false);
  }, [activePageInfo, lang, pageNum]);

  return (
    <div>
      <Nav_pc />
      <Nav_mo
        totalMenuOpen={totalMenuOpen}
        setTotalMenuOpen={setTotalMenuOpen}
      />
      <TotalMenu totalMenuOpen={totalMenuOpen} />
    </div>
  );
}

function Nav_pc() {
  const { activePageInfo, lang, pageNum, autoplayRunning } = useContext(CatalogContext);
  if (!activePageInfo || !lang) {
    return null;
  }

  if (lang === 'ko') {
    return (
      <div className='nav--pc'>
        <aside className='sidebar'>
          <CatalogLink
            to={2}
            className='btn btn--home'
          >
            <svg
              className='svg--home'
              xmlns='http://www.w3.org/2000/svg'
              width='28.999'
              height='31.024'
              viewBox='0 0 28.999 31.024'
            >
              <path
                id='path--home'
                data-name='path--home'
                d='M4223.559-7289.745h-9.441v8.769h-6.069v-14.163H4204L4218.5-7312l14.5,16.861h-3.371v14.162h-6.07Z'
                transform='translate(-4204.001 7312.001)'
                fill='#fff'
              />
            </svg>
          </CatalogLink>
          <hr />
          <AutoplayButton className={`btn btn--play ${autoplayRunning ? 'pause' : 'play'}`}>
            <svg
              className='svg--play'
              xmlns='http://www.w3.org/2000/svg'
              width={37}
              height={36}
              viewBox='0 0 35.999 36'
            >
              <path
                id='path--play'
                data-name='path--play'
                d='M4222-7276a17.88,17.88,0,0,1-12.727-5.272A17.883,17.883,0,0,1,4204-7294a17.884,17.884,0,0,1,5.271-12.728A17.88,17.88,0,0,1,4222-7312a17.883,17.883,0,0,1,12.729,5.272A17.882,17.882,0,0,1,4240-7294a17.88,17.88,0,0,1-5.272,12.728A17.883,17.883,0,0,1,4222-7276Zm-5-26h0v17l14-8.5-14-8.5Z'
                transform='translate(-4204.001 7312)'
                fill='#fff'
              />
            </svg>
            <svg
              className='svg--pause'
              xmlns='http://www.w3.org/2000/svg'
              width={36}
              height={36}
              viewBox='0 0 36 36'
            >
              <g
                id='그룹_18700'
                data-name='그룹 18700'
                transform='translate(-16.999 -87)'
              >
                <path
                  d='M4222-7312a18,18,0,0,1,18,18,18,18,0,0,1-18,18,18,18,0,0,1-18-18A18,18,0,0,1,4222-7312Z'
                  transform='translate(-4187.001 7399)'
                  fill='#fff'
                />
                <rect
                  width={5}
                  height={19}
                  transform='translate(27 96)'
                  fill='#4e484a'
                />
                <rect
                  width={5}
                  height={19}
                  transform='translate(38 96)'
                  fill='#4e484a'
                />
              </g>
            </svg>
          </AutoplayButton>
          <hr />
          <div className='mnu_container'>
            <nav className={`mnu ${activePageInfo?.depth1 === 'introduce' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'overview' ? 'active' : ''}`}
                to={3}
              >
                Overview
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'technology' ? 'active' : ''}`}
                to={12}
              >
                Technology
              </CatalogLink>
            </nav>
            <nav className={`mnu theme--red ${activePageInfo?.depth1 === 'vk' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                to={17}
              >
                VI-Killer
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'spec' ? 'active' : ''}`}
                to={19}
              >
                Specification
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'cert' ? 'active' : ''}`}
                to={22}
              >
                Certification
              </CatalogLink>
            </nav>
            <nav className={`mnu theme--green ${activePageInfo?.depth1 === 'vtx' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                to={24}
              >
                VTX
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'app' ? 'active' : ''}`}
                to={25}
              >
                Application
              </CatalogLink>
            </nav>
            <nav className={`mnu theme--navy ${activePageInfo?.depth1 === 'dg' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                to={26}
              >
                DEGER
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'feat' ? 'active' : ''}`}
                to={27}
              >
                Feature
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'cert' ? 'active' : ''}`}
                to={29}
              >
                Certification
              </CatalogLink>
            </nav>
          </div>
          <hr />
          <CatalogLink
            className='btn btn--sitemap catalog__link'
            to={2}
          >
            <svg
              className='svg--hambuger'
              xmlns='http://www.w3.org/2000/svg'
              width={29}
              height={23}
              viewBox='0 0 29 23'
            >
              <g transform='translate(-592.402 -643)'>
                <rect
                  id='path--bar1'
                  data-name='path--bar1'
                  width={29}
                  height={5}
                  transform='translate(592.402 643)'
                  fill='#fff'
                />
                <rect
                  id='path--bar2'
                  data-name='path--bar2'
                  width={29}
                  height={5}
                  transform='translate(592.402 652)'
                  fill='#fff'
                />
                <rect
                  id='path--bar3'
                  data-name='path--bar3'
                  width={29}
                  height={5}
                  transform='translate(592.402 661)'
                  fill='#fff'
                />
              </g>
            </svg>
          </CatalogLink>
        </aside>
        <nav className='controlls'>
          <PrevButton className='btn btn--prev'>
            <svg
              className='svg--prev'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.695'
              viewBox='0 0 21.474 31.695'
            >
              <path
                id='path--prev'
                data-name='path--prev'
                d='M21.474,15.762,6.865,1.154a3.939,3.939,0,0,0-5.571,5.57l9.055,9.054-9.2,9.195a3.939,3.939,0,0,0,5.57,5.57l14.75-14.75-.015-.015Z'
                transform='translate(21.474 31.695) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
          </PrevButton>
          <NextButton className='btn btn--next'>
            <svg
              className='svg--next'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.697'
              viewBox='0 0 21.474 31.697'
            >
              <path
                id='path--next'
                data-name='path--next'
                d='M0,15.763,14.61,1.154a3.939,3.939,0,1,1,5.571,5.57l-9.055,9.054,9.2,9.195a3.939,3.939,0,1,1-5.57,5.57L0,15.793l.015-.015Z'
                transform='translate(21.474 31.697) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
          </NextButton>
        </nav>
        <div className='etc_nav'>
          <nav className='nav--lang'>
            <CatalogLink
              to={`/en/${pageNum}`}
              type='absolute'
              className={`btn--lang ${lang === 'en' ? 'active' : ''}`}
            >
              <img
                src={`${CONFIG.IMG_URL}/common/flag-usa.svg`}
                alt=''
                className='flag'
              />
              <span>ENG</span>
            </CatalogLink>
            <CatalogLink
              to={`/ko/${pageNum}`}
              type='absolute'
              className={`btn--lang ${lang === 'ko' ? 'active' : ''}`}
            >
              <img
                src={`${CONFIG.IMG_URL}/common/flag-ko.svg`}
                alt=''
                className='flag'
              />
              <span>KOR</span>
            </CatalogLink>
          </nav>
          <a
            href='//www.vi-killer.com'
            className='logo'
            target='_blank'
          >
            <img
              src={`${CONFIG.IMG_URL}/common/symbol.svg`}
              alt='Vi-Killer'
            />
          </a>
        </div>
        <nav className='lnb_container'>
          <div className={`lnb_group ${activePageInfo?.depth1 === 'introduce' ? 'active' : ''}`}>
            <ul className={`lnb ${activePageInfo?.depth2 === 'overview' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'what' ? 'active' : ''}`}>
                <CatalogLink
                  className={`catalog__link ${activePageInfo?.depth1 === 'aaa' ? 'active' : ''}`}
                  to={3}
                >
                  하이브리드 방역이란?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'necessary' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={4}
                >
                  왜 필요한가요?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'how_possible' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={5}
                >
                  어떻게 가능한가요?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'difference' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={6}
                >
                  기존 방역과 어떻게 다른가요?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'high-price' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={7}
                >
                  비용이 높지 않을까요?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'application' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={8}
                >
                  어디에 적용할 수 있나요?
                </CatalogLink>
              </li>
            </ul>
            <ul className={`lnb ${activePageInfo?.depth2 === 'technology' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'disease_block' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={12}
                >
                  전 세계 학계가 검증한 감염병 차단 효과
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'report' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={13}
                >
                  과학적으로 제공하는 맞춤형 방역 레포트
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'sterilization_1' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={14}
                >
                  실제 공간 살균 효과 비교
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'sterilization_2' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={15}
                >
                  실제 병원 공간 살균 효과
                </CatalogLink>
              </li>
            </ul>
          </div>
          <div className={`lnb_group theme--red ${activePageInfo?.depth1 === 'vk' ? 'active' : ''}`}>
            <ul className={`lnb ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'intro' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={17}
                >
                  제품소개
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'strength' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={18}
                >
                  특장점
                </CatalogLink>
              </li>
            </ul>
            <ul className={`lnb ${activePageInfo?.depth2 === 'spec' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'free' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={19}
                >
                  Free
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'jumbo' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={20}
                >
                  Jumbo
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'mini' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={21}
                >
                  Mini
                </CatalogLink>
              </li>
            </ul>
            <div
              className='lnb__bg vk_spec_lnb_bg'
              style={{ backgroundImage: `url("${CONFIG.IMG_URL}/common/vk_lnb_bg.jpg")` }}
            />
            <div className='vk_lnb_thumb'>
              <div className='rotate'>
                <div className='item item--free'>
                  <img
                    src={`${CONFIG.IMG_URL}/common/vk_lnb_thumb_free.png`}
                    alt=''
                    className=''
                  />
                </div>
                <div className='item item--jumbo'>
                  <img
                    src={`${CONFIG.IMG_URL}/common/vk_lnb_thumb_jumbo.png`}
                    alt=''
                    className=''
                  />
                </div>
                <div className='item item--mini'>
                  <img
                    src={`${CONFIG.IMG_URL}/common/vk_lnb_thumb_mini.png`}
                    alt=''
                    className=''
                  />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  } else {
    return (
      <div className='nav--pc'>
        <aside className='sidebar'>
          <CatalogLink
            to={2}
            className='btn btn--home'
          >
            <svg
              className='svg--home'
              xmlns='http://www.w3.org/2000/svg'
              width='28.999'
              height='31.024'
              viewBox='0 0 28.999 31.024'
            >
              <path
                id='path--home'
                data-name='path--home'
                d='M4223.559-7289.745h-9.441v8.769h-6.069v-14.163H4204L4218.5-7312l14.5,16.861h-3.371v14.162h-6.07Z'
                transform='translate(-4204.001 7312.001)'
                fill='#fff'
              />
            </svg>
          </CatalogLink>
          <hr />
          <AutoplayButton className={`btn btn--play ${autoplayRunning ? 'pause' : 'play'}`}>
            <svg
              className='svg--play'
              xmlns='http://www.w3.org/2000/svg'
              width={37}
              height={36}
              viewBox='0 0 35.999 36'
            >
              <path
                id='path--play'
                data-name='path--play'
                d='M4222-7276a17.88,17.88,0,0,1-12.727-5.272A17.883,17.883,0,0,1,4204-7294a17.884,17.884,0,0,1,5.271-12.728A17.88,17.88,0,0,1,4222-7312a17.883,17.883,0,0,1,12.729,5.272A17.882,17.882,0,0,1,4240-7294a17.88,17.88,0,0,1-5.272,12.728A17.883,17.883,0,0,1,4222-7276Zm-5-26h0v17l14-8.5-14-8.5Z'
                transform='translate(-4204.001 7312)'
                fill='#fff'
              />
            </svg>
            <svg
              className='svg--pause'
              xmlns='http://www.w3.org/2000/svg'
              width={36}
              height={36}
              viewBox='0 0 36 36'
            >
              <g
                id='그룹_18700'
                data-name='그룹 18700'
                transform='translate(-16.999 -87)'
              >
                <path
                  d='M4222-7312a18,18,0,0,1,18,18,18,18,0,0,1-18,18,18,18,0,0,1-18-18A18,18,0,0,1,4222-7312Z'
                  transform='translate(-4187.001 7399)'
                  fill='#fff'
                />
                <rect
                  width={5}
                  height={19}
                  transform='translate(27 96)'
                  fill='#4e484a'
                />
                <rect
                  width={5}
                  height={19}
                  transform='translate(38 96)'
                  fill='#4e484a'
                />
              </g>
            </svg>
          </AutoplayButton>
          <hr />
          <div className='mnu_container'>
            <nav className={`mnu ${activePageInfo?.depth1 === 'introduce' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'overview' ? 'active' : ''}`}
                to={3}
              >
                Overview
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'technology' ? 'active' : ''}`}
                to={12}
              >
                Technology
              </CatalogLink>
            </nav>
            <nav className={`mnu theme--red ${activePageInfo?.depth1 === 'vk' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                to={17}
              >
                VI-Killer
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'spec' ? 'active' : ''}`}
                to={19}
              >
                Specification
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'cert' ? 'active' : ''}`}
                to={22}
              >
                Certification
              </CatalogLink>
            </nav>
            <nav className={`mnu theme--green ${activePageInfo?.depth1 === 'vtx' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                to={24}
              >
                VTX
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'app' ? 'active' : ''}`}
                to={25}
              >
                Application
              </CatalogLink>
            </nav>
            <nav className={`mnu theme--navy ${activePageInfo?.depth1 === 'dg' ? 'active' : ''}`}>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                to={26}
              >
                DEGER
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'feat' ? 'active' : ''}`}
                to={27}
              >
                Feature
              </CatalogLink>
              <CatalogLink
                className={`mnu__item catalog__link ${activePageInfo?.depth2 === 'cert' ? 'active' : ''}`}
                to={29}
              >
                Certification
              </CatalogLink>
            </nav>
          </div>
          <hr />
          <CatalogLink
            className='btn btn--sitemap catalog__link'
            to={2}
          >
            <svg
              className='svg--hambuger'
              xmlns='http://www.w3.org/2000/svg'
              width={29}
              height={23}
              viewBox='0 0 29 23'
            >
              <g transform='translate(-592.402 -643)'>
                <rect
                  id='path--bar1'
                  data-name='path--bar1'
                  width={29}
                  height={5}
                  transform='translate(592.402 643)'
                  fill='#fff'
                />
                <rect
                  id='path--bar2'
                  data-name='path--bar2'
                  width={29}
                  height={5}
                  transform='translate(592.402 652)'
                  fill='#fff'
                />
                <rect
                  id='path--bar3'
                  data-name='path--bar3'
                  width={29}
                  height={5}
                  transform='translate(592.402 661)'
                  fill='#fff'
                />
              </g>
            </svg>
          </CatalogLink>
        </aside>
        <nav className='controlls'>
          <PrevButton className='btn btn--prev'>
            <svg
              className='svg--prev'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.695'
              viewBox='0 0 21.474 31.695'
            >
              <path
                id='path--prev'
                data-name='path--prev'
                d='M21.474,15.762,6.865,1.154a3.939,3.939,0,0,0-5.571,5.57l9.055,9.054-9.2,9.195a3.939,3.939,0,0,0,5.57,5.57l14.75-14.75-.015-.015Z'
                transform='translate(21.474 31.695) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
          </PrevButton>
          <NextButton className='btn btn--next'>
            <svg
              className='svg--next'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.697'
              viewBox='0 0 21.474 31.697'
            >
              <path
                id='path--next'
                data-name='path--next'
                d='M0,15.763,14.61,1.154a3.939,3.939,0,1,1,5.571,5.57l-9.055,9.054,9.2,9.195a3.939,3.939,0,1,1-5.57,5.57L0,15.793l.015-.015Z'
                transform='translate(21.474 31.697) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
          </NextButton>
        </nav>
        <div className='etc_nav'>
          <nav className='nav--lang'>
            <CatalogLink
              to={`/en/${pageNum}`}
              type='absolute'
              className={`btn--lang ${lang === 'en' ? 'active' : ''}`}
            >
              <img
                src={`${CONFIG.IMG_URL}/common/flag-usa.svg`}
                alt=''
                className='flag'
              />
              <span>ENG</span>
            </CatalogLink>
            <CatalogLink
              to={`/ko/${pageNum}`}
              type='absolute'
              className={`btn--lang ${lang === 'ko' ? 'active' : ''}`}
            >
              <img
                src={`${CONFIG.IMG_URL}/common/flag-ko.svg`}
                alt=''
                className='flag'
              />
              <span>KOR</span>
            </CatalogLink>
          </nav>
          <a
            href='//www.vi-killer.com/?lang=en'
            className='logo'
            target='_blank'
          >
            <img
              src={`${CONFIG.IMG_URL}/common/symbol.svg`}
              alt='Vi-Killer'
            />
          </a>
        </div>
        <nav className='lnb_container'>
          <div className={`lnb_group ${activePageInfo?.depth1 === 'introduce' ? 'active' : ''}`}>
            <ul className={`lnb ${activePageInfo?.depth2 === 'overview' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'what' ? 'active' : ''}`}>
                <CatalogLink
                  className={`catalog__link ${activePageInfo?.depth1 === 'aaa' ? 'active' : ''}`}
                  to={3}
                >
                  What’s <br />
                  Hybrid Disinfection?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'necessary' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={4}
                >
                  Why <br />
                  Hybrid Disinfection?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'how_possible' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={5}
                >
                  Concept of the method
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'difference' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={6}
                >
                  How different from the conventional way?
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'high-price' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={7}
                >
                  Economical way of disinfection
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'application' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={8}
                >
                  Applications
                </CatalogLink>
              </li>
            </ul>
            <ul className={`lnb ${activePageInfo?.depth2 === 'technology' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'disease_block' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={12}
                >
                  The result verified by the global academic community
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'report' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={13}
                >
                  Customized reports scientifically validated
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'sterilization_1' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={14}
                >
                  Disinfection effects in actual spaces
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'sterilization_2' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={15}
                >
                  Disinfection effects in actual hospital spaces
                </CatalogLink>
              </li>
            </ul>
          </div>
          <div className={`lnb_group theme--red ${activePageInfo?.depth1 === 'vk' ? 'active' : ''}`}>
            <ul className={`lnb ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'intro' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={17}
                >
                  Introduction
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'strength' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={18}
                >
                  Features
                </CatalogLink>
              </li>
            </ul>
            <ul className={`lnb ${activePageInfo?.depth2 === 'spec' ? 'active' : ''}`}>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'free' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={19}
                >
                  Free
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'jumbo' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={20}
                >
                  Jumbo
                </CatalogLink>
              </li>
              <li className={`lnb__item ${activePageInfo?.depth3 === 'mini' ? 'active' : ''}`}>
                <CatalogLink
                  className='catalog__link'
                  to={21}
                >
                  Mini
                </CatalogLink>
              </li>
            </ul>
            <div
              className='lnb__bg vk_spec_lnb_bg'
              style={{ backgroundImage: `url("${CONFIG.IMG_URL}/common/vk_lnb_bg.jpg")` }}
            />
            <div className='vk_lnb_thumb'>
              <div className='rotate'>
                <div className='item item--free'>
                  <img
                    src={`${CONFIG.IMG_URL}/common/vk_lnb_thumb_free.png`}
                    alt=''
                    className=''
                  />
                </div>
                <div className='item item--jumbo'>
                  <img
                    src={`${CONFIG.IMG_URL}/common/vk_lnb_thumb_jumbo.png`}
                    alt=''
                    className=''
                  />
                </div>
                <div className='item item--mini'>
                  <img
                    src={`${CONFIG.IMG_URL}/common/vk_lnb_thumb_mini.png`}
                    alt=''
                    className=''
                  />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

function Nav_mo({ totalMenuOpen, setTotalMenuOpen }) {
  const { activePageInfo, lang, pageNum, autoplayRunning } = useContext(CatalogContext);
  if (!activePageInfo || !lang) {
    return null;
  }

  if (lang === 'ko') {
    return (
      <div className='nav--m'>
        <header
          id='m-header'
          className='header'
        >
          <h1 className='logo'>
            <CatalogLink
              className='catalog__link'
              to={2}
            >
              <img
                src={`${CONFIG.IMG_URL}/common/symbol.svg`}
                alt='Vi-Killer'
              />
            </CatalogLink>
          </h1>
          <nav>
            <div className='nav--lang'>
              <CatalogLink
                to={`/en/${pageNum}`}
                type='absolute'
                className={`btn--lang ${lang === 'en' ? 'active' : ''}`}
              >
                <img
                  src={`${CONFIG.IMG_URL}/common/flag-usa.svg`}
                  alt=''
                  className='flag'
                />
              </CatalogLink>
              <CatalogLink
                to={`/ko/${pageNum}`}
                type='absolute'
                className={`btn--lang ${lang === 'ko' ? 'active' : ''}`}
              >
                <img
                  src={`${CONFIG.IMG_URL}/common/flag-ko.svg`}
                  alt=''
                  className='flag'
                />
              </CatalogLink>
            </div>
            <AutoplayButton className={`btn btn--play ${autoplayRunning ? 'pause' : 'play'}`}>
              <svg
                className='svg--play'
                xmlns='http://www.w3.org/2000/svg'
                width='35.999'
                height={36}
                viewBox='0 0 35.999 36'
              >
                <path
                  id='path--play'
                  data-name='path--play'
                  d='M4222-7276a17.88,17.88,0,0,1-12.727-5.272A17.883,17.883,0,0,1,4204-7294a17.884,17.884,0,0,1,5.271-12.728A17.88,17.88,0,0,1,4222-7312a17.883,17.883,0,0,1,12.729,5.272A17.882,17.882,0,0,1,4240-7294a17.88,17.88,0,0,1-5.272,12.728A17.883,17.883,0,0,1,4222-7276Zm-5-26h0v17l14-8.5-14-8.5Z'
                  transform='translate(-4204.001 7312)'
                  fill='#fff'
                />
              </svg>
              <svg
                className='svg--pause'
                xmlns='http://www.w3.org/2000/svg'
                width={36}
                height={36}
                viewBox='0 0 36 36'
              >
                <g
                  id='그룹_18700'
                  data-name='그룹 18700'
                  transform='translate(-16.999 -87)'
                >
                  <path
                    d='M4222-7312a18,18,0,0,1,18,18,18,18,0,0,1-18,18,18,18,0,0,1-18-18A18,18,0,0,1,4222-7312Z'
                    transform='translate(-4187.001 7399)'
                    fill='#fff'
                  />
                  <rect
                    width={5}
                    height={19}
                    transform='translate(27 96)'
                    fill='#4e484a'
                  />
                  <rect
                    width={5}
                    height={19}
                    transform='translate(38 96)'
                    fill='#4e484a'
                  />
                </g>
              </svg>
            </AutoplayButton>
          </nav>
        </header>
        <nav className='controlls'>
          <PrevButton className='btn btn--prev'>
            <svg
              className='svg--prev'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.695'
              viewBox='0 0 21.474 31.695'
            >
              <path
                id='path--prev'
                data-name='path--prev'
                d='M21.474,15.762,6.865,1.154a3.939,3.939,0,0,0-5.571,5.57l9.055,9.054-9.2,9.195a3.939,3.939,0,0,0,5.57,5.57l14.75-14.75-.015-.015Z'
                transform='translate(21.474 31.695) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
            <span className='txt'>PREV</span>
          </PrevButton>
          <button
            id='btn--total'
            className={`btn btn--sitemap ${totalMenuOpen ? 'active' : ''}`}
            onClick={() => setTotalMenuOpen(prev => !prev)}
          >
            <svg
              className='svg--hambuger'
              xmlns='http://www.w3.org/2000/svg'
              width={29}
              height={23}
              viewBox='0 0 29 23'
            >
              <g transform='translate(-592.402 -643)'>
                <rect
                  id='path--bar1'
                  data-name='path--bar1'
                  width={29}
                  height={5}
                  transform='translate(592.402 643)'
                  fill={'#fff'}
                />
                <rect
                  id='path--bar2'
                  data-name='path--bar2'
                  width={29}
                  height={5}
                  transform='translate(592.402 652)'
                  fill={'#fff'}
                />
                <rect
                  id='path--bar3'
                  data-name='path--bar3'
                  width={29}
                  height={5}
                  transform='translate(592.402 661)'
                  fill={'#fff'}
                />
              </g>
            </svg>
          </button>
          <NextButton className='btn btn--next'>
            <span className='txt'>NEXT</span>
            <svg
              className='svg--next'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.697'
              viewBox='0 0 21.474 31.697'
            >
              <path
                id='path--next'
                data-name='path--next'
                d='M0,15.763,14.61,1.154a3.939,3.939,0,1,1,5.571,5.57l-9.055,9.054,9.2,9.195a3.939,3.939,0,1,1-5.57,5.57L0,15.793l.015-.015Z'
                transform='translate(21.474 31.697) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
          </NextButton>
        </nav>
      </div>
    );
  } else {
    return (
      <div className='nav--m'>
        <header
          id='m-header'
          className='header'
        >
          <h1 className='logo'>
            <CatalogLink
              className='catalog__link'
              to={2}
            >
              <img
                src={`${CONFIG.IMG_URL}/common/symbol.svg`}
                alt='Vi-Killer'
              />
            </CatalogLink>
          </h1>
          <nav>
            <div className='nav--lang'>
              <CatalogLink
                to={`/en/${pageNum}`}
                type='absolute'
                className={`btn--lang ${lang === 'en' ? 'active' : ''}`}
              >
                <img
                  src={`${CONFIG.IMG_URL}/common/flag-usa.svg`}
                  alt=''
                  className='flag'
                />
              </CatalogLink>
              <CatalogLink
                to={`/ko/${pageNum}`}
                type='absolute'
                className={`btn--lang ${lang === 'ko' ? 'active' : ''}`}
              >
                <img
                  src={`${CONFIG.IMG_URL}/common/flag-ko.svg`}
                  alt=''
                  className='flag'
                />
              </CatalogLink>
            </div>
            <AutoplayButton className={`btn btn--play ${autoplayRunning ? 'pause' : 'play'}`}>
              <svg
                className='svg--play'
                xmlns='http://www.w3.org/2000/svg'
                width='35.999'
                height={36}
                viewBox='0 0 35.999 36'
              >
                <path
                  id='path--play'
                  data-name='path--play'
                  d='M4222-7276a17.88,17.88,0,0,1-12.727-5.272A17.883,17.883,0,0,1,4204-7294a17.884,17.884,0,0,1,5.271-12.728A17.88,17.88,0,0,1,4222-7312a17.883,17.883,0,0,1,12.729,5.272A17.882,17.882,0,0,1,4240-7294a17.88,17.88,0,0,1-5.272,12.728A17.883,17.883,0,0,1,4222-7276Zm-5-26h0v17l14-8.5-14-8.5Z'
                  transform='translate(-4204.001 7312)'
                  fill='#fff'
                />
              </svg>
              <svg
                className='svg--pause'
                xmlns='http://www.w3.org/2000/svg'
                width={36}
                height={36}
                viewBox='0 0 36 36'
              >
                <g
                  id='그룹_18700'
                  data-name='그룹 18700'
                  transform='translate(-16.999 -87)'
                >
                  <path
                    d='M4222-7312a18,18,0,0,1,18,18,18,18,0,0,1-18,18,18,18,0,0,1-18-18A18,18,0,0,1,4222-7312Z'
                    transform='translate(-4187.001 7399)'
                    fill='#fff'
                  />
                  <rect
                    width={5}
                    height={19}
                    transform='translate(27 96)'
                    fill='#4e484a'
                  />
                  <rect
                    width={5}
                    height={19}
                    transform='translate(38 96)'
                    fill='#4e484a'
                  />
                </g>
              </svg>
            </AutoplayButton>
          </nav>
        </header>
        <nav className='controlls'>
          <PrevButton className='btn btn--prev'>
            <svg
              className='svg--prev'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.695'
              viewBox='0 0 21.474 31.695'
            >
              <path
                id='path--prev'
                data-name='path--prev'
                d='M21.474,15.762,6.865,1.154a3.939,3.939,0,0,0-5.571,5.57l9.055,9.054-9.2,9.195a3.939,3.939,0,0,0,5.57,5.57l14.75-14.75-.015-.015Z'
                transform='translate(21.474 31.695) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
            <span className='txt'>PREV</span>
          </PrevButton>
          <button
            id='btn--total'
            className={`btn btn--sitemap ${totalMenuOpen ? 'active' : ''}`}
            onClick={() => setTotalMenuOpen(prev => !prev)}
          >
            <svg
              className='svg--hambuger'
              xmlns='http://www.w3.org/2000/svg'
              width={29}
              height={23}
              viewBox='0 0 29 23'
            >
              <g transform='translate(-592.402 -643)'>
                <rect
                  id='path--bar1'
                  data-name='path--bar1'
                  width={29}
                  height={5}
                  transform='translate(592.402 643)'
                  fill={'#fff'}
                />
                <rect
                  id='path--bar2'
                  data-name='path--bar2'
                  width={29}
                  height={5}
                  transform='translate(592.402 652)'
                  fill={'#fff'}
                />
                <rect
                  id='path--bar3'
                  data-name='path--bar3'
                  width={29}
                  height={5}
                  transform='translate(592.402 661)'
                  fill={'#fff'}
                />
              </g>
            </svg>
          </button>
          <NextButton className='btn btn--next'>
            <span className='txt'>NEXT</span>
            <svg
              className='svg--next'
              xmlns='http://www.w3.org/2000/svg'
              width='21.474'
              height='31.697'
              viewBox='0 0 21.474 31.697'
            >
              <path
                id='path--next'
                data-name='path--next'
                d='M0,15.763,14.61,1.154a3.939,3.939,0,1,1,5.571,5.57l-9.055,9.054,9.2,9.195a3.939,3.939,0,1,1-5.57,5.57L0,15.793l.015-.015Z'
                transform='translate(21.474 31.697) rotate(180)'
                fill='#a7a7a7'
              />
            </svg>
          </NextButton>
        </nav>
      </div>
    );
  }
}

function TotalMenu({ totalMenuOpen }) {
  const { activePageInfo, lang, pageNum } = useContext(CatalogContext);
  const year = new Date().getFullYear();
  return (
    <article
      id='total_menu'
      className={`total_menu ${totalMenuOpen ? 'active' : ''}`}
    >
      <div className='dimmer' />
      <div className='menu_container'>
        <div className='head'>
          <h3 className='title'>
            <img
              src={`${CONFIG.IMG_URL}/common/vk_logo_white.svg`}
              alt=''
            />
          </h3>
          <nav className='category'>
            <CatalogLink
              to={`/ko/${pageNum}`}
              type='absolute'
              className={lang === 'ko' ? 'active' : ''}
            >
              KOREAN
            </CatalogLink>
            <CatalogLink
              to={`/en/${pageNum}`}
              type='absolute'
              className={lang === 'en' ? 'active' : ''}
            >
              ENGLISH
            </CatalogLink>
          </nav>
        </div>
        <div className='body'>
          <ul className='index_menu'>
            <li>
              <CatalogLink
                className={`catalog__link depth1 ${activePageInfo?.depth1 === 'introduce' ? 'active' : ''}`}
                to={2}
              >
                <span className='sbj'>HYBRID DISINFECTION</span>
                <span className='no' />
              </CatalogLink>
              <ul>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'overview' ? 'active' : ''}`}
                    to={3}
                  >
                    Overview
                  </CatalogLink>
                  <ul>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'what' ? 'active' : ''}`}
                        to={3}
                      >
                        {lang === 'ko' ? '하이브리드 방역이란?' : "What's Hybrid Disinfection?"}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'necessary' ? 'active' : ''}`}
                        to={4}
                      >
                        {lang === 'ko' ? '왜 필요한가요?' : 'Why Hybrid Disinfection?'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'how_possible' ? 'active' : ''}`}
                        to={5}
                      >
                        {lang === 'ko' ? '어떻게 가능한가요?' : 'Concept of the method'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'difference' ? 'active' : ''}`}
                        to={6}
                      >
                        {lang === 'ko' ? '기존 방역과 어떻게 다른가요?' : 'How different from the conventional way?'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'high-price' ? 'active' : ''}`}
                        to={7}
                      >
                        {lang === 'ko' ? '비용이 높지 않을까요?' : 'Economical way of disinfection'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'application' ? 'active' : ''}`}
                        to={8}
                      >
                        {lang === 'ko' ? '어디에 적용할 수 있나요?' : 'Applications'}
                      </CatalogLink>
                      <ul>
                        <li>
                          <CatalogLink
                            className={`catalog__link depth4 ${activePageInfo?.depth4 === 'app1' ? 'active' : ''}`}
                            to={8}
                          >
                            {lang === 'ko' ? '실제 적용 사례' : 'Recent cases'}
                          </CatalogLink>
                        </li>
                        <li>
                          <CatalogLink
                            className={`catalog__link depth4 ${activePageInfo?.depth4 === 'app2' ? 'active' : ''}`}
                            to={9}
                          >
                            {lang === 'ko'
                              ? '다중 이용 공간 / 감염 취약 공간'
                              : 'High-traffic multi-purpose facilities'}
                          </CatalogLink>
                        </li>
                        <li>
                          <CatalogLink
                            className={`catalog__link depth4 ${activePageInfo?.depth4 === 'app3' ? 'active' : ''}`}
                            to={10}
                          >
                            {lang === 'ko' ? '생활 공간' : 'Spaces in daily lives'}
                          </CatalogLink>
                        </li>
                        <li>
                          <CatalogLink
                            className={`catalog__link depth4 ${activePageInfo?.depth4 === 'app4' ? 'active' : ''}`}
                            to={11}
                          >
                            {lang === 'ko' ? '환기가 어려운 공간' : 'Spaces with poor ventilation'}
                          </CatalogLink>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'technology' ? 'active' : ''}`}
                    to={12}
                  >
                    Technology
                  </CatalogLink>
                  <ul>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'disease_block' ? 'active' : ''}`}
                        to={12}
                      >
                        {lang === 'ko'
                          ? '전 세계 학계가 검증한 감염병 차단 효과'
                          : 'The result verified by the global academic community'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'report' ? 'active' : ''}`}
                        to={13}
                      >
                        {lang === 'ko'
                          ? '과학적으로 제공하는 맞춤형 방역 레포트'
                          : 'Customized reports scientifically validated'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${
                          activePageInfo?.depth3 === 'sterilization_1' ? 'active' : ''
                        }`}
                        to={14}
                      >
                        {lang === 'ko' ? '실제 공간 살균 효과 비교' : 'Disinfection effects in actual spaces'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${
                          activePageInfo?.depth3 === 'sterilization_2' ? 'active' : ''
                        }`}
                        to={15}
                      >
                        {lang === 'ko' ? '실제 병원 공간 살균 효과' : 'Disinfection effects in actual hospital spaces'}
                      </CatalogLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <CatalogLink
                className={`catalog__link depth1 ${activePageInfo?.depth1 === 'vk' ? 'active' : ''}`}
                to={16}
              >
                <span className='sbj'>Vi-Killer</span>
                <span className='no' />
              </CatalogLink>
              <ul>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                    to={17}
                  >
                    {lang === 'ko' ? 'Vi-Killer 소개' : 'Vi-Killer Introduction'}
                  </CatalogLink>
                  <ul>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'intro' ? 'active' : ''}`}
                        to={17}
                      >
                        {lang === 'ko' ? '제품소개' : 'Introduction'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'strength' ? 'active' : ''}`}
                        to={18}
                      >
                        {lang === 'ko' ? '특장점' : 'Fetures'}
                      </CatalogLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'spec' ? 'active' : ''}`}
                    to={19}
                  >
                    {lang === 'ko' ? '제품 스펙' : 'Specifications'}
                  </CatalogLink>
                  <ul>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'free' ? 'active' : ''}`}
                        to={19}
                      >
                        {lang === 'ko' ? 'FREE' : 'Vi-Killer FREE'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'jumbo' ? 'active' : ''}`}
                        to={20}
                      >
                        {lang === 'ko' ? 'JUMBO' : 'Vi-Killer JUMBO'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'mini' ? 'active' : ''}`}
                        to={21}
                      >
                        {lang === 'ko' ? 'MINI' : 'Vi-Killer MINI'}
                      </CatalogLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'cert' ? 'active' : ''}`}
                    to={22}
                  >
                    {lang === 'ko' ? '제품 인증' : 'Certificates'}
                  </CatalogLink>
                </li>
              </ul>
            </li>
            <li>
              <CatalogLink
                className={`catalog__link depth1 ${activePageInfo?.depth1 === 'vtx' ? 'active' : ''}`}
                to={23}
              >
                <span className='sbj'>VTX</span>
                <span className='no' />
              </CatalogLink>
              <ul>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                    to={24}
                  >
                    {lang === 'ko' ? 'VTX 소개' : 'VTX Introduction'}
                  </CatalogLink>
                </li>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'app' ? 'active' : ''}`}
                    to={25}
                  >
                    {lang === 'ko' ? '적용 사례' : 'Applications'}
                  </CatalogLink>
                </li>
              </ul>
            </li>
            <li>
              <CatalogLink
                className={`catalog__link depth1 ${activePageInfo?.depth1 === 'dg' ? 'active' : ''}`}
                to={26}
              >
                <span className='sbj'>Deger</span>
                <span className='no' />
              </CatalogLink>
              <ul>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'about' ? 'active' : ''}`}
                    to={26}
                  >
                    {lang === 'ko' ? 'Deger 소개' : 'Deger Introduction'}
                  </CatalogLink>
                </li>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'feat' ? 'active' : ''}`}
                    to={27}
                  >
                    {lang === 'ko' ? 'Deger 특장점' : 'Deger Features'}
                  </CatalogLink>
                  <ul>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'safety' ? 'active' : ''}`}
                        to={27}
                      >
                        {lang === 'ko' ? '안전성' : 'Safer for everyone'}
                      </CatalogLink>
                    </li>
                    <li>
                      <CatalogLink
                        className={`catalog__link depth3 ${activePageInfo?.depth3 === 'range' ? 'active' : ''}`}
                        to={28}
                      >
                        {lang === 'ko' ? '살균력' : 'Cleaner for everyone'}
                      </CatalogLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <CatalogLink
                    className={`catalog__link depth2 ${activePageInfo?.depth2 === 'cert' ? 'active' : ''}`}
                    to={29}
                  >
                    {lang === 'ko' ? '제품 인증' : 'Certificates'}
                  </CatalogLink>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className='foot'>
          <div className='group'>
            <nav className='nav--sns'>
              <a
                href='https://www.youtube.com/@vikillerglobal'
                target='_blank'
              >
                <i className='fa-brands fa-youtube' />
              </a>
              <a
                href={`http://vi-killer.com/${lang === 'ko' ? '' : '?lang=en'}`}
                target='_blank'
              >
                <svg
                  id='vk_path'
                  data-name='그룹 18486'
                  xmlns='http://www.w3.org/2000/svg'
                  xmlnsXlink='http://www.w3.org/1999/xlink'
                  width='47.351'
                  height='55.278'
                  viewBox='0 0 47.351 55.278'
                >
                  <defs>
                    <clipPath id='clip-path'>
                      <rect
                        id='사각형_9003'
                        data-name='사각형 9003'
                        width='47.351'
                        height='55.278'
                        fill='none'
                      />
                    </clipPath>
                  </defs>
                  <g
                    id='그룹_18485'
                    data-name='그룹 18485'
                    clipPath='url(#clip-path)'
                  >
                    <path
                      id='패스_10617'
                      data-name='패스 10617'
                      d='M23.675,55.278l-.082-.01a21.932,21.932,0,0,1-7.421-2.459c-5.224-2.655-8.884-5.5-11.19-8.7C2.531,40.712,1.189,37.07.5,31.934A83.843,83.843,0,0,1,0,20.609L0,8.183l.623-.054c.058,0,5.823-.512,8.635-1.147,4.754-1.075,8.768-3.53,13.017-6.129L23.675,0l1.4.852c4.249,2.6,8.264,5.054,13.017,6.129,2.814.636,8.577,1.142,8.635,1.147l.623.054,0,12.431a83.781,83.781,0,0,1-.494,11.32c-.693,5.137-2.035,8.778-4.487,12.178-2.306,3.2-5.966,6.042-11.189,8.7a21.953,21.953,0,0,1-7.422,2.459ZM1.367,9.43l0,11.182a82.8,82.8,0,0,0,.482,11.14c.661,4.9,1.929,8.357,4.242,11.562,2.175,3.017,5.676,5.725,10.7,8.278A20.757,20.757,0,0,0,23.675,53.9a20.78,20.78,0,0,0,6.886-2.312c5.025-2.554,8.525-5.262,10.7-8.278,2.312-3.205,3.581-6.663,4.242-11.563a82.735,82.735,0,0,0,.482-11.135l0-11.186A82.051,82.051,0,0,1,37.79,8.312c-4.972-1.124-9.271-3.753-13.428-6.3L23.675,1.6l-.685.418c-4.157,2.543-8.455,5.172-13.429,6.3A82.053,82.053,0,0,1,1.367,9.43'
                      transform='translate(0)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10618'
                      data-name='패스 10618'
                      d='M178.007,294.678a2.811,2.811,0,0,0-2.676,3.686l6.868,21.05h7.863l-3.339-9.8-5.082-14.933Z'
                      transform='translate(-166.118 -279.42)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10619'
                      data-name='패스 10619'
                      d='M442.281,570.49a1.756,1.756,0,1,0,1.755-1.757,1.756,1.756,0,0,0-1.755,1.757'
                      transform='translate(-419.381 -539.285)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10620'
                      data-name='패스 10620'
                      d='M415.452,489.852a1.477,1.477,0,1,0,1.476-1.476,1.476,1.476,0,0,0-1.476,1.476'
                      transform='translate(-393.941 -463.089)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10621'
                      data-name='패스 10621'
                      d='M486.153,489.852a1.476,1.476,0,1,0,1.477-1.476,1.476,1.476,0,0,0-1.477,1.476'
                      transform='translate(-460.981 -463.089)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10622'
                      data-name='패스 10622'
                      d='M434.785,417.326a1.119,1.119,0,1,0,1.119-1.12,1.118,1.118,0,0,0-1.119,1.12'
                      transform='translate(-412.273 -394.656)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10623'
                      data-name='패스 10623'
                      d='M488.351,417.326a1.119,1.119,0,1,0,1.12-1.12,1.119,1.119,0,0,0-1.12,1.12'
                      transform='translate(-463.065 -394.656)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10624'
                      data-name='패스 10624'
                      d='M541.928,417.326a1.118,1.118,0,1,0,1.119-1.12,1.118,1.118,0,0,0-1.119,1.12'
                      transform='translate(-513.868 -394.656)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10625'
                      data-name='패스 10625'
                      d='M444.347,359.7a.822.822,0,1,0,.823-.823.823.823,0,0,0-.823.823'
                      transform='translate(-421.34 -340.292)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10626'
                      data-name='패스 10626'
                      d='M483.733,359.7a.823.823,0,1,0,.823-.823.823.823,0,0,0-.823.823'
                      transform='translate(-458.687 -340.292)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10627'
                      data-name='패스 10627'
                      d='M523.132,359.7a.823.823,0,1,0,.823-.823.823.823,0,0,0-.823.823'
                      transform='translate(-496.046 -340.292)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10628'
                      data-name='패스 10628'
                      d='M562.531,359.7a.823.823,0,1,0,.823-.823.823.823,0,0,0-.823.823'
                      transform='translate(-533.404 -340.292)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10629'
                      data-name='패스 10629'
                      d='M458.016,309.161a.666.666,0,1,0,.666-.666.666.666,0,0,0-.666.666'
                      transform='translate(-434.301 -292.522)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10630'
                      data-name='패스 10630'
                      d='M497.258,309.161a.666.666,0,1,0,.666-.666.666.666,0,0,0-.666.666'
                      transform='translate(-471.511 -292.522)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10631'
                      data-name='패스 10631'
                      d='M536.514,309.161a.666.666,0,1,0,.665-.666.665.665,0,0,0-.665.666'
                      transform='translate(-508.735 -292.522)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10632'
                      data-name='패스 10632'
                      d='M575.755,309.161a.666.666,0,1,0,.666-.666.666.666,0,0,0-.666.666'
                      transform='translate(-545.944 -292.522)'
                      fill='#fff'
                    />
                    <path
                      id='패스_10633'
                      data-name='패스 10633'
                      d='M645.254,423.569a1.991,1.991,0,0,1-1.472-.575,1.921,1.921,0,0,1-.574-1.41,1.852,1.852,0,0,1,.574-1.4,2.271,2.271,0,0,1,2.95,0,1.86,1.86,0,0,1,.568,1.4,1.913,1.913,0,0,1-.568,1.428,2.017,2.017,0,0,1-1.478.557m1.753,14.355h-3.552V425.53h3.552Z'
                      transform='translate(-609.904 -397.908)'
                      fill='#fff'
                    />
                  </g>
                </svg>
              </a>
            </nav>
            <span className='copyright'>Copyright {year} TRACOWORLD LTD All rights reseved.</span>
          </div>
        </div>
      </div>
    </article>
  );
}
